import MfaConfirmation from '../../views/MfaConfirmation.vue';
export default [
  {
    path: '/mfa-confirmation',
    name: 'MfaConfirmation',
    component: MfaConfirmation
  }
];